import { Component, Mixins } from 'vue-property-decorator';
import { BaseStoreEditComponent } from '../components/base-store-edit-component';

@Component
export default class UnsavedChangesHookMixin extends Mixins() {
    async beforeRouteLeave(to, from, next) {
        if (!(this instanceof BaseStoreEditComponent)) { return next() }

        return await (this as BaseStoreEditComponent<any>).confirmUnsavedChanges()
            ? next()
            : next(false)
    }
}
